// YERİ: src/app/domains/website/sections/mkt-host.ts
// Vitrinin bölüm dağıtıcısı: BlockType → pazarlama bileşeni.
//
// Neden paylaşımlı sec-host'a EKLEMEDİK: oradaki `imports:` dizisi lazy değil.
// Pazarlama bölümlerini oraya koysaydık 18 bileşen her tenant sitesinin
// paketine de girerdi — müşteri sitesi melbarrel.com'un fiyat tablosunu asla
// çizmeyecek olmasına rağmen indirirdi.
//
// Bilinmeyen tipler sec-host'a DELEGE edilir: yapısal bloklar (text/image/
// button/row/custom-html) ve CMS'te zaten var olan eski bölümler çalışmaya
// devam eder. Yani bu host mevcut kataloğu genişletir, değiştirmez.

import { Component, computed, input } from '@angular/core';
import { SectionHost } from '@/app/domains/site/sections/section-host';
import { SiteSection } from '@/app/domains/site/core/tenant-web.service';
import { parseConfig } from '@/app/domains/site/sections/section.model';
import { MktCtaBandSection, MktHeroSection, MktLogoWallSection } from './mkt-hero.sections';
import { MktFooterSection, MktNavbarSection } from './mkt-chrome.sections';
import {
  MktFeatureSplitSection,
  MktFeatureTabsSection,
  MktMetricsSection,
  MktModuleGridSection,
  MktTestimonialsSection,
} from './mkt-content.sections';
import { MktFaqSection, MktLeadFormSection, MktPricingSection } from './mkt-convert.sections';
import { MktServicesSection } from './mkt-services.section';
import { MktServiceCatalogSection } from './mkt-service-catalog.section';
import { MktRoadmapSection } from './mkt-roadmap.section';
import { MktLegalSection } from './mkt-legal.section';

@Component({
  selector: 'mkt-host',
  standalone: true,
  // display:contents — bu eleman KUTU OLUŞTURMAMALI.
  //
  // Varsayılan haliyle (block) üst menüyü sarmalayan mkt-host, menü kadar
  // (113px) yüksekliğinde bir kutu yaratıyordu. `position: sticky` elemanı
  // EBEVEYNİNİN kutusu içinde hapistir — menü 113px'lik kutusundan çıkamıyor,
  // yani sayfa kaydırılınca yukarıda KALMIYOR, gidiyordu. Yapışkan menü hiç
  // çalışmamış; SSR testleri bunu göremez (kaydırma yok), curl hiç göremez.
  //
  // Bölümlerin hepsi kendi host'unda `block` taşıyor, o yüzden sarmalayıcıyı
  // kaldırmak yerleşimi bozmaz.
  host: { class: 'contents' },
  imports: [
    SectionHost,
    MktNavbarSection, MktFooterSection,
    MktHeroSection, MktLogoWallSection, MktCtaBandSection,
    MktFeatureSplitSection, MktFeatureTabsSection, MktModuleGridSection, MktMetricsSection, MktTestimonialsSection,
    MktServicesSection, MktServiceCatalogSection, MktRoadmapSection, MktLegalSection,
    MktPricingSection, MktFaqSection, MktLeadFormSection,
  ],
  template: `
    @switch (section().sectionType) {
      @case ('mkt-navbar')        { <mkt-navbar [config]="cfg()" /> }
      @case ('mkt-footer')        { <mkt-footer [config]="cfg()" /> }
      @case ('mkt-hero')          { <mkt-hero [config]="cfg()" /> }
      @case ('mkt-logo-wall')     { <mkt-logo-wall [config]="cfg()" /> }
      @case ('mkt-feature-split') { <mkt-feature-split [config]="cfg()" /> }
      @case ('mkt-feature-tabs')  { <mkt-feature-tabs [config]="cfg()" /> }
      @case ('mkt-services')      { <mkt-services [config]="cfg()" /> }
      @case ('mkt-service-catalog') { <mkt-service-catalog [config]="cfg()" [lead]="lead()" /> }
      @case ('mkt-module-grid')   { <mkt-module-grid [config]="cfg()" /> }
      @case ('mkt-metrics')       { <mkt-metrics [config]="cfg()" /> }
      @case ('mkt-testimonials')  { <mkt-testimonials [config]="cfg()" /> }
      @case ('mkt-pricing')       { <mkt-pricing [config]="cfg()" [lead]="lead()" /> }
      @case ('mkt-faq')           { <mkt-faq [config]="cfg()" [lead]="lead()" /> }
      @case ('mkt-lead-form')     { <mkt-lead-form [config]="cfg()" [lead]="lead()" /> }
      @case ('mkt-roadmap')       { <mkt-roadmap [config]="cfg()" /> }
      @case ('mkt-cta-band')      { <mkt-cta-band [config]="cfg()" /> }
      @case ('mkt-legal')         { <mkt-legal [config]="cfg()" /> }

      @default {
        <!-- Pazarlama bölümü değil → paylaşımlı renderer çizsin.
             clientId=0: bu tenant'a ait bir site DEĞİL, platformun kendi vitrini. -->
        <sec-host [section]="section()" [preview]="preview()" [clientId]="0" />
      }
    }
  `,
})
export class MktHost {
  readonly section = input.required<SiteSection>();
  /** Editör önizlemesinde bilinmeyen tipler yer tutucu gösterir; canlıda gizli. */
  readonly preview = input<boolean>(false);

  /**
   * Sayfanın İLK bölümü mü?
   *
   * Bölümler başlıklarını h2 olarak basar; h1'i hero üretir. Ama her sayfa
   * hero ile açılmıyor (fiyatlandırma doğrudan fiyat tablosuyla, iletişim
   * formla başlıyor) — o sayfalar h1'siz kalıyordu. Sayfanın ilk bölümü kendi
   * başlığını h1'e yükseltir; başlık sırası bozulmaz ve admin'den açılan yeni
   * bir sayfa da hangi bölümle başlarsa başlasın h1 kazanır.
   */
  readonly lead = input<boolean>(false);

  protected cfg = computed(() => parseConfig(this.section().config));
}
